import React from "react";

interface OrderInfoCardProps {
  icon?: React.ReactNode;
  header?: string;
  children: React.ReactNode;
}

const OrderOverviewCard = ({ icon, header, children }: OrderInfoCardProps) => {
  return (
    <div className="card">
      <div className="card-body">
        {icon && (
          <div className="flex items-center justify-center size-12 rounded-md ltr:float-right rtl:float-left">
            {icon}
          </div>
        )}
        {header && <h6 className="mb-4 text-15">{header}</h6>}
        {children}
      </div>
    </div>
  );
};

export default OrderOverviewCard;
